const namespace = 'reports/property-click'

export default function propertyClickReport({ apiClient }) {
  return {
    clicks(params) {
      return apiClient.get(`${namespace}/clicks`, {}, params)
    },
    resume() {
      return apiClient.get(`${namespace}/resume`, {}, {})
    },
    count() {
      return apiClient.get(`${namespace}/count`, {}, {})
    }
  }
}
